<template>
  <a-select
    v-model="record.platformLabelId"
    style="width: 160px"
    v-if="labelOrOption"
    @change="typeChange"
  >
    <a-select-option v-for="item in list" :key="item.id" :value="item.id">{{
      item.name
    }}</a-select-option>
  </a-select>
  <a-select
    v-model="record.platformOptionId"
    style="width: 280px"
    v-else-if="qualificationOptionList && mode == 'default'"
    mode="default"
  >
    <a-select-option
      v-for="item in qualificationOptionList"
      :key="item.id"
      :value="item.id"
      >{{ item.content }}</a-select-option
    >
  </a-select>
  <a-select
    v-model="record.platformOptionIdList"
    style="width: 280px"
    v-else-if="qualificationOptionList && mode == 'multiple'"
    mode="multiple"
    :maxTagCount="1"
    :maxTagTextLength="10"
  >
    <a-select-option
      v-for="item in qualificationOptionList"
      :key="item.id"
      :value="item.id"
      >{{ item.content }}</a-select-option
    >
  </a-select>
</template>

<script>
import api from "../lib/formMaintenance.js";
export default {
  props: ["record", "labelOrOption",'modelId'],
  data() {
    return {
      list: [],
      mode: "default",
    };
  },
  watch: {
    "record.type": {
      immediate: true,
      handler(newVal) {
        if (newVal == "OPTION") {
          this.mode = "default";
        } else if (newVal == "RANDOM_OPTION") {
          this.mode = "multiple";
        }
      },
    },
  },
  computed: {
    qualificationOptionList() {
      let qualificationOptionList = [];
      this.list.forEach((item) => {
        if (item.id == this.record.platformLabelId) {
          if (item.qualificationOptionList) {
            qualificationOptionList = item.qualificationOptionList;
          }
        }
      });
      return qualificationOptionList;
    },
  },
  created() {
    api
      .listPlatformQualification({
        platformId: this.record.platformId,
        modelId: this.modelId,
      })
      .then((res) => {
        if (res.result == 200) {
          this.list = res.data;
        }
      });
  },
  methods: {
    typeChange() {
      this.record.platformOptionIdList = [];
      this.record.platformOptionId = undefined;
    },
  },
};
</script>

<style></style>
